import React, {useState, useEffect} from "react";

import {Form} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import CreatePasswordFields from "./CreatePasswordFields";

import {useDispatch, useSelector} from "react-redux";
import {login, register as registerFunc} from "actions/auth";
import {hideModal, setShowVerifyEmail, showLogin} from "actions/ui_control";
import {Link, useNavigate} from "react-router-dom";

function RegisterLastStep({
                            isFirstStep,
                            setFormState,
                            formState,
                            setIsFirstStep,
                          }) {
  // Password requirements. We keep that since react hook form return only the first failed requirement
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const { message } = useSelector(state => state.message);

  // Validation schema
  const schema = yup.object().shape({
    password: yup
      .string()
      .min(8)
      .required()
      .matches(/[A-Z]/)
      .matches(/[a-z]/)
      .matches(/\d/),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords do not match")
      .required("Please confirm the password"),
    termsAndConditions: yup.boolean().oneOf([true], ""),
  });
  const {
    register,
    handleSubmit,
    formState: {errors},
    watch,
    getValues,
  } = useForm({
    defaultValues: {
      password: formState.password,
      confirmPassword: formState.confirmPassword,
      termsAndConditions: formState.termsAndConditions,
    },
    mode: "onChange",
    // Define validation schema
    resolver: yupResolver(schema),
  });
  // Watch password input changes
  // Update formState on switching between steps
  useEffect(() => {
    setFormState(prev => ({...prev, ...getValues()}));
  }, [isFirstStep]);
  // Function to check if password requirements are passed

  //
  const finalSubmit = formValues => {
    setFormState(prev => ({...prev, ...formValues}));
    const {username, email, password} = {...formState, ...formValues};

    setLoading(true);
    dispatch(registerFunc(username, email, password))
      .then(() => {
        dispatch(login(email, password, false))
          .then(() => {
            navigate("/dashboard");
            dispatch(hideModal());

            // dispatch(setShowVerifyEmail());
            // onLoginCallback();
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(err => {
        console.log({err});
        setError(err);
        setTimeout(() => {
          if (err === "user with this email already exists.") {
            dispatch(showLogin());
          } else {
            setIsFirstStep(true);
          }
        }, 1000);
        setTimeout(() => setError(null), 5000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {/* Mount/Unmount functionality is set here in order to not lose defined values on step change */}
      {!isFirstStep && (
        <Form sm={12} noValidate onSubmit={handleSubmit(finalSubmit)}>
          <CreatePasswordFields
            register={register}
            errors={errors}
            watch={watch}
          />
          <Form.Group>
            <Form.Check
              className={errors.termsAndConditions ? "is-invalid" : "is-valid"}
              type="checkbox"
              label={<a href="/terms" target="_blank" rel="noopener noreferrer">Agree to Terms and Conditions</a>}
              {...register("termsAndConditions")}
              isInvalid={errors.termsAndConditions}
            />
          </Form.Group>
          <div className="form-group pt-2 pb-2 d-flex flex-column gap-2">
            <button
              type="submit"
              className="btn btn-primary btn-block btn-full"
              disabled={loading}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Sign Up
            </button>
            <button
              type="button"
              className="btn btn-primary-outline btn-block btn-outline-full position-relative"
              disabled={loading}
              onClick={() => {
                setIsFirstStep(true);
              }}
            >
              <i
                className="bi bi-arrow-left back-arrow position-absolute"
                style={{
                  left: "30%",
                  top: "50%",
                  transform: "translate(0, -50%)",
                  padding: "3.5px",
                  cursor: "pointer",
                  marginLeft: "10px",
                  fontSize: "20px",
                }}
              ></i>{" "}
              Back
            </button>
          </div>
          {error && (
            <div className="form-group mt-2">
              <div className="alert alert-danger" role="alert">
                <React.Fragment>{error}</React.Fragment>
              </div>
            </div>
          )}
        </Form>
      )}
    </>
  );
}

export default RegisterLastStep;
